export const MenuConfig = [];

/*** APP ITEMS */
MenuConfig.push(
    {
        title: "AD Settings",
        group: "apps",
        icon: "mdi-ballot",
        name: "m-redactor-ad-settings"
    },

    {
        title: "Avatars",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-avatars"
    },

    {
        title: "MapAddon",
        group: "apps",
        icon: "mdi-ballot",
        name: "m-redactor-map-addon"
    },
    {
        title: "Cards",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-cards"
    },
    {
        title: "Card Clusters",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-card-clusters"
    },
    {
        title: "Card Packages",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-card-packages"
    },
    {
        title: "Boosters",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-boosters"
    },
    {
        title: "Boats",
        group: "apps",
        icon: "mdi-ballot",
        name: "m-redactor-boats"
    },
    {
        title: "Server Events",
        group: "apps",
        icon: "mdi-ballot",
        name: "m-redactor-server-events"
    },
    {
        title: "Harry Trader",
        group: "apps",
        icon: "mdi-ballot",
        name: "m-redactor-trader"
    },
    {
        title: "Product Items",
        group: "apps",
        icon: "mdi-ballot",
        name: "m-redactor-product-items"
    },
    {
        title: "Product Groups",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-product-groups"
    },

    {
        title: "Reward Packages",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-reward-packages"
    },
    {
        title: "Recipes",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-recipes"
    },
    {
        title: "Quests",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-quests"
    },

    {
        title: "Discoveries",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-discoveries"
    },
    {
        title: "Currencies",
        group: "apps",
        icon: "mdi-ballot",
        name: "m-redactor-currencies-holder"
    },
    {
        title: "Exchange",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-exchange"
    },
    {
        title: "Fireflies",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-fireflies"
    },
    {
        title: "FirefliesV2",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-fireflies-v2"
    },
    {
        title: "Levels",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-levels"
    },
    {
        title: "Map Kind",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-map-kind"
    },
    {
        title: "Map Group",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-map-group"
    },
    {
        title: "Talks",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-talks"
    },
    {
        title: "Tutorials",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-tutorials"
    },
    {
      title: "Items",
      group: "apps",
      icon: "mdi-ballot",
      name: "m-redactor-items-holder"
    },
    {
        title: "Smart Offers",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-smart-offers"
    },
    {
        title: "Daily Quest",
        group: "apps",
        icon: "mdi-ballot",
        name: "m-redactor-daily-quest"
    },
    {
        title: "Daily Bonus",
        group: "apps",
        icon: "mdi-ballot",
        name: "m-redactor-daily-bonus"
    },
    {
        title: "Swamps",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-swamps"
    },
    {
        title: "Notifications",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-prompts"
    },
    {
        title: "World Regions",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-world-regions"
    },
    {
        title: "World Region Territories",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-world-region-territories"
    },
    {
        title: "Worker Kind",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-worker-kind"
    },
    {
        title: "Worker Team",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-worker-teams"
    },
    {
        title: "Settings",
        group: "apps",
        icon: "mdi-ballot-outline",
        name: "m-redactor-settings"
    }
);


MenuConfig.forEach(item => {
    if (item.items) {
        item.items.sort((x, y) => {
            let textA = x.title.toUpperCase();
            let textB = y.title.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
    }
});

export function buildOrdered(defaultItems, savedNames = []) {
  const byName = new Map(defaultItems.map(it => [it.name, it]));
  const savedNamesClean = savedNames.filter(n => byName.has(n));
  const savedSet = new Set(savedNamesClean);
  const result = savedNamesClean.map(n => byName.get(n));
  const rebuildPos = () => new Map(result.map((it, idx) => [it.name, idx]));
  let pos = rebuildPos();

  const insertAfter = (anchorName, item) => {
    const i = pos.get(anchorName);
    const at = (i == null) ? result.length : i + 1;
    result.splice(at, 0, item);
    pos = rebuildPos();
  };

  const findLeftSavedAnchor = (defaultIdx) => {
    for (let j = defaultIdx - 1; j >= 0; j--) {
      const name = defaultItems[j].name;
      if (savedSet.has(name)) return name;
    }
    return null;
  };

  for (let idx = 0; idx < defaultItems.length; idx++) {
    const item = defaultItems[idx];
    const name = item.name;
    if (savedSet.has(name)) continue;

    const leftAnchor = findLeftSavedAnchor(idx);

    if (leftAnchor) {
      insertAfter(leftAnchor, item);
    } else if (result.length > 0) {
      const firstSavedName = result[0].name;
      insertAfter(firstSavedName, item);
    } else {
      result.push(item);
      pos = rebuildPos();
    }
  }

  return result;
}

